import { memo } from 'react';

import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';
import { useStore } from '@spazious/dollhouse-store';
import { ToolModeEnum } from '@spazious/dollhouse-types';

import { PolygonDrawControls } from '../PolygonDrawControls/index.js';

export const FAreaControls = memo(() => {
  const tool = useStore(({ tool }) => tool);

  return tool === ToolModeEnum.FArea ? (
    <PolygonDrawControls type={FShallowNodeTypesEnum.FArea} />
  ) : null;
});
